module.exports = __webpack_public_path__ + "static/media/send-right.91ef7623.svg";